import type { ViewProps } from 'react-native'
import { Icon } from '~/components/icon'
import * as S from './product-info.styles'

export interface ProductInfoProps extends ViewProps {
  productDescription: string
  productBrand?: string
  productDetail?: string
  productQuantity?: string
  marketingDescription?: string
  oficialMarketing?: boolean
  pimTagOptions?: string
}

const Info = ({
  productDescription,
  productBrand,
  productDetail,
  productQuantity,
  marketingDescription,
  oficialMarketing,
  pimTagOptions,
  ...rest
}: ProductInfoProps) => {
  return (
    <S.InfoContainer {...rest}>
      {pimTagOptions && (
        <S.PimTagContainer>
          <S.PimTagLabel numberOfLines={1}>{pimTagOptions}</S.PimTagLabel>
        </S.PimTagContainer>
      )}
      <S.InfoTitle numberOfLines={2}>{productDescription}</S.InfoTitle>
      {productQuantity && (
        <S.InfoQuantity numberOfLines={1}>{productQuantity}</S.InfoQuantity>
      )}
      {productBrand &&
        <S.InfoBrand numberOfLines={1}>{productBrand}</S.InfoBrand>
      }
      {productDetail && (
        <S.InfoDetail numberOfLines={1}>{productDetail}</S.InfoDetail>
      )}
      {marketingDescription && (
        <S.InfoMarketplaceContainer>
          <S.InfoMarketplaceText numberOfLines={1}>
            {marketingDescription}
          </S.InfoMarketplaceText>
          {oficialMarketing && (
            <Icon
              size="tiny"
              symbol="rdicon-verified-filled"
              color="colorTextSuccessAlternative"
            />
          )}
        </S.InfoMarketplaceContainer>
      )}
    </S.InfoContainer>
  )
}

export { Info }
